<template>
  <div>
    <b-container>
      <h1 class="text-left mt-2 mb-4">Fogalomtár</h1>
      <b-row>
        <b-col>
          <h3 class="text-left mt-2 mb-4">Keresés</h3>
          <b-form-input
            id="definitions-filter-input"
            class="mt-2 mb-2 p-4"
            v-model="filter"
            type="search"
            placeholder="A kereséshez írja be a kívánt fogalmat"
          ></b-form-input>
          <b-table
            hover
            :busy="isBusy"
            :filter="filter"
            :fields="fields"
            :items="definitions"
            :currentPage="currentPage"
            :per-page="perPage"
            :outlined="true"
            table-class="definitions-tbl"
            @row-clicked="itemClicked"
          ></b-table>
        </b-col>
      </b-row>
      <b-row>
        <b-col></b-col>
        <b-col sm="auto">
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            size="md"
            class="definitions-pagination"
          ></b-pagination>
        </b-col>
        <b-col></b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { getRelatedDefinitions } from '../../api/knowledgebase'

export default {
  name: 'Knowledgebase',
  components: {},
  data() {
    return {
      isBusy: true,
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      filter: null,
      fields: [
        {
          key: 'name',
          filter: null,
          sortable: true,
          label: 'Fogalom'
        }
      ],
      definitions: []
    }
  },
  methods: {
    itemClicked(i) {
      this.$router.push(`/knowledgebase/${i.slug}`, () => {})
    }
  },
  async created() {
    this.isBusy = true
    this.definitions = await getRelatedDefinitions()
    this.totalRows = this.definitions.length
    this.isBusy = false
  }
}
</script>

<style>
#definitions-filter-input {
  border: 1px solid #00903c;
  border-radius: 8px;
  color: #00903c;
}
.definitions-tbl td {
  cursor: pointer;
}
.definitions-pagination .page-link {
  color: #00903c;
}

.definitions-pagination .page-item.active .page-link {
  background-color: #00903c;
}
</style>
